<template>
  <div class="opple-ability-ui-com-input">
    <el-input-number
      v-model="value"
      :min="item.Min"
      :max="item.Max"
      :disabled="item.Readonly"
      class="ip_input input_left"
      :title="(item.Min != undefined ? item.Min : '') + '-' + ( item.Max!=undefined ? item.Max : '')"
      @change="onValueChange"
    />
    <span class="opple-ability-ui-com-input_unit">{{ item.ParaUnit }}</span>
  </div>
</template>

<script>
import { NEIGHBOR_GROUP } from '@/utils/enums';

function isHexString(item) {
  return item.KeyId === 224;
}

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      value: ''
    }
  },

  computed: {
   
  },

  mounted() {
    this.initValue();
  },

  methods: {
    onValueChange(e){
      // try {
      //   if(this.item.UI.Precision){
      //     this.value = e.DefaultValue.toFixed(1)
      //   }
      // } catch (error) {
      // }
    },

    initValue() {
      const { DefaultValue } = this.item;

      if (DefaultValue) {
        if (isHexString(this.item)) {
          this.value = +DefaultValue - parseInt(NEIGHBOR_GROUP, 16);
        } else {
          this.value = DefaultValue;
        }
        
      }
    },

    getData() {
      const { item } = this;
      let hasUIPrecision = !!item.UI && !!item.UI.Precision;

      if (isHexString(item)) {
        return {
          Key: item.KeyId,
          Values: [`${(parseInt(NEIGHBOR_GROUP, 16) + this.value)}`]
        }
      }

      if(hasUIPrecision){
        const precision = item.UI.Precision.split('.')[1].split('').length * 10;
  
        return {
          Key: item.KeyId,
          Values: `${this.value * precision}`.split(',')
        }
      } else {
        return {
          Key: item.KeyId,
          Values: `${this.value}`.split(',')
        }
      }
    }
  },
};
</script>

<style lang="scss">
.opple-ability-ui-form {
  .opple-ability-ui-com-input {
    position: relative;
    display: flex;

    .ip_input {
      position: relative;
      right: auto;
    }

    &_unit {
      position: absolute;
      right: -44px;
      font-size: 12px;
    }
  }
}

</style>
